import { Navigate, Route, Routes } from 'react-router-dom'
import ScreenHolding from '../../../Pages/Screen/ScreenHolding'
import ScreenCollection from '../../../Pages/Screen/ScreenCollection/ScreenCollection'
import ScreenComplete from '../../../Pages/Screen/ScreenComplete'
import ScreenManage from '../../../Pages/Screen/ManageScreens/ScreenManage'
import ScreenReport from '../../../Pages/Screen/ScreenReport/ScreenReport'
import ResultsReport from '../../../Pages/Screen/ResultsReport/ResultsReport'
import * as React from 'react'
import CreateScreen from '../../../Pages/Screen/New&Clone/CreateScreen'
import SelectedScreenModule from '../../../Contexts/Modules/HealthModule/SelectedScreenModule'
import SelectedScreenRouter from './SelectedScreenRouter'
import ManifestReport from '../../../Pages/Screen/ScreenReport/ManifestReport'

function HealthRouter() {
  return (
    <Routes>
      <Route
        path={'*'}
        element={
          <Navigate
            to={'complete'}
            replace={true}
          />
        }
      />
      <Route
        path="complete"
        element={<ScreenComplete />}
      />
      <Route path="screen">
        <Route
          element={<CreateScreen />}
          index
        />
        <Route
          path=":screen_id/*"
          element={
            <SelectedScreenModule>
              <SelectedScreenRouter />
            </SelectedScreenModule>
          }
        />
      </Route>
      <Route
        path="manage"
        element={<ScreenManage />}
      />
      <Route
        path="report/manifest"
        element={<ManifestReport />}
      />
      <Route
        path="report/screen"
        element={<ScreenReport manifest={false} />}
      />
      <Route
        path="report/results"
        element={<ResultsReport />}
      />
      <Route
        path="holding/:holding_id"
        element={<ScreenHolding />}
      />
      <Route
        path="collections/:collection_id"
        element={<ScreenCollection />}
      />
    </Routes>
  )
}
export default HealthRouter
